/* Simple class to keep track of internal value and provide convenience functions */
export var Position;
(function (Position) {
    Position["Year"] = "year";
    Position["Month"] = "month";
    Position["Day"] = "day";
    Position["All"] = "all";
})(Position || (Position = {}));
export function parseFormat(iStr) {
    var _a, _b;
    let resArr = [];
    let parts;
    let sep = iStr.replace(/[ymdYMD]+/g, '').substr(0, 1);
    let fullYear = false;
    // TODO handle empty sep
    if (sep == '') {
    }
    else {
        parts = (_a = iStr.split(sep)) !== null && _a !== void 0 ? _a : [];
        for (let i = 0; i < 3; i++) {
            switch ((_b = parts[i]) === null || _b === void 0 ? void 0 : _b.toLowerCase()) {
                case 'yyyy': {
                    resArr.push(Position.Year);
                    fullYear = true;
                    break;
                }
                case 'yy': {
                    resArr.push(Position.Year);
                    fullYear = false;
                    break;
                }
                case 'mm': {
                    resArr.push(Position.Month);
                    break;
                }
                case 'dd': {
                    resArr.push(Position.Day);
                    break;
                }
            }
        }
    }
    if (!(resArr[0] && resArr[1] && resArr[2]))
        resArr = [Position.Year, Position.Month, Position.Day];
    //@ts-ignore
    return { sep: sep, fullYear: fullYear, posArr: resArr };
}
export class Calendar {
    constructor(args) {
        if (args.dateString)
            this.date = new Date(args.dateString.substring(0, 4) + '-' + args.dateString.substring(4, 6) + '-' + args.dateString.substring(6));
        else if (args.dateObj)
            this.date = args.dateObj;
        else
            this.date = new Date();
        this.sep = args.sep;
        this.fullYear = args.fullYear;
        this.order = args.order;
    }
    addDay() {
        this.date.setDate(this.date.getDate() + 1);
    }
    addMonth() {
        this.date.setMonth(this.date.getMonth() + 1);
    }
    addYear() {
        this.date.setFullYear(this.date.getFullYear() + 1);
    }
    subtDay() {
        this.date.setDate(this.date.getDate() - 1);
    }
    subtMonth() {
        this.date.setMonth(this.date.getMonth() - 1);
    }
    subtYear() {
        this.date.setFullYear(this.date.getFullYear() - 1);
    }
    inputDay(iDay) {
        this.date.setDate(iDay);
    }
    inputMonth(iMonth) {
        this.date.setMonth(iMonth);
    }
    inputYear(iYear) {
        this.date.setFullYear(iYear);
    }
    clearDay() {
        this.date.setDate(0);
    }
    clearMonth() {
        this.date.setMonth(0);
    }
    clearYear() {
        this.date.setFullYear(new Date(Date.now()).getFullYear());
    }
    setValue(iDay, iMonth, iYear, isDay) {
        if (iDay == 0)
            iDay = 1;
        let yearStr = iYear.toString();
        if (yearStr.length < 4) {
            iYear = 2000 + parseInt(yearStr);
        }
        this.date.setFullYear(isNaN(iYear) ? 0 : iYear);
        this.date.setMonth(isNaN(iMonth) ? 0 : iMonth - 1);
        this.date.setDate(isNaN(iDay) ? 0 : iDay);
    }
    setDate(iDate) {
        this.date = iDate;
    }
    inputDigit(iDig, iPos) {
        let y = this.date.getFullYear();
        let m = this.date.getMonth();
        let d = this.date.getDate();
        switch (iPos) {
            case Position.Day: {
                this.date.setFullYear(y + iDig);
                break;
            }
            case Position.Month: {
                this.date.setMonth(iDig - 1);
                break;
            }
            case Position.Year: {
                this.date.setDate(d + iDig);
                break;
            }
        }
    }
    getDaysInCurMonth(month) {
        let m = this.date.getMonth();
        let y = this.date.getFullYear();
        if (month !== undefined)
            m = month;
        let have31Days = [0, 2, 4, 6, 7, 9, 11];
        let have30Days = [3, 5, 8, 10];
        let isLeapYear = (y % 4 == 0 && y % 100 != 0) || y % 400 == 0;
        if (have31Days.indexOf(m) !== -1)
            return 31;
        if (have30Days.indexOf(m) !== -1)
            return 30;
        if (m === 1)
            return isLeapYear ? 29 : 28;
        return 0;
    }
    reset() {
        this.date = new Date(Date.now());
    }
    getDateObject() {
        return this.date;
    }
    /* format result according to PICDate format */
    toString() {
        let res = '';
        for (let i = 0; i < 3; i++) {
            switch (this.order[i]) {
                case Position.Year: {
                    if (this.fullYear) {
                        res += (this.date.getFullYear() + '').padStart(4, '0') + this.sep;
                    }
                    else {
                        res += ((this.date.getFullYear() + '').padStart(4, '0')).substr(2) + this.sep;
                    }
                    break;
                }
                case Position.Month: {
                    res += ((this.date.getMonth() + 1) + '').padStart(2, '0') + this.sep;
                    break;
                }
                case Position.Day: {
                    res += (this.date.getDate() + '').padStart(2, '0') + this.sep;
                    break;
                }
            }
        }
        return res.slice(0, -1);
    }
    toReturnValue() {
        return (this.date.getFullYear() + '').padStart(4, '0') + '-' + ((this.date.getMonth() + 1) + '').padStart(2, '0') + '-' + (this.date.getDate() + '').padStart(2, '0');
    }
}
//# sourceMappingURL=Calendar.js.map